import { render, staticRenderFns } from "./SmartBanner.vue?vue&type=template&id=0ffb504a&scoped=true"
import script from "./SmartBanner.vue?vue&type=script&lang=ts"
export * from "./SmartBanner.vue?vue&type=script&lang=ts"
import style0 from "./SmartBanner.vue?vue&type=style&index=0&id=0ffb504a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb504a",
  null
  
)

export default component.exports